import axios from "axios";
import { clear_local_storage } from "../Utils/data";

const instance = axios.create({
  // baseURL: "http://10.10.10.39:3033/",
  baseURL: "https://addmin-api.payzap.io/",
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.data.error.statusCode === 401) {
        clear_local_storage();
      }
    }
    return Promise.reject(error);
  }
);

const token = localStorage.getItem("token");
if (token) {
  instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export default instance;
